export default {
  transaction_record: {
    title: '集团充值及提现',
    filter_date: '充值/提现时间',
    search_keyword: '交易单号 / 集团',
    transaction_amount: '交易金额',
    prop: {
      trade_number: '交易单号',
      amount: '交易金额 (元)',
      account_balance: '交易后余额 (元)',
      payment_type: '交易方式',
      transaction_type: '交易类型',
      created_at: '交易时间'
    },
    show: {
      order_number: '交易单号',
      group: '集团',
      type: '交易类型	',
      payment_type: '支付方式',
      amount: '金额',
      after_amount: '交易后余额',
      time: '时间',
      operator: '操作员',
      note: '备注'
    },
    transaction_type: {
      top_up: '充值',
      withdraw: '提现',
      charge_consume: '充电消费',
      product_trade: '商品购物',
      idle_fee_consume: '占位费消费'
    },
    transaction_types: {
      top_up: '充值',
      withdraw: '提现',
      charge_consume: '充电消费',
      product_trade: '商品购物',
      refund: '订单退款',
      idle_fee_consume: '占位费消费'
    },
    payment_types: {
      wechat: '微信',
      alipay: '支付宝',
      apple_pay: 'ApplyPay',
      balance_pay: '余额支付',
      union_pay: '银联支付',
      offline_pay: '平台充值',
      ccb_pay: '建行支付',
      group_balance_pay: '集团支付',
      refund_pay: '退款'
    }
  }
}
